import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StepperDataService } from 'src/app/services/general/stepper-data.service';

@Component({
  selector: 'app-stepper',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent {
  isGreen = false;

  @Input() activeStep: number = 1;

  actualStep: string[] = [];
  nextStep: string[] = [];
  lenthActualStep: number = 0;

  constructor(private stepperDataService: StepperDataService) {
    this.actualStep = this.stepperDataService.actualStep;
    this.nextStep = this.stepperDataService.nextStep;
    this.lenthActualStep = this.stepperDataService.lengthActualStep();
    

    
  }

  ngOnInit(): void { }
}
